import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Card, CardBody, Button } from 'reactstrap';

const PaymentResult: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const sessionId = searchParams.get('session_id');
        const error = searchParams.get('error');
        
        if (error) {
            setStatus('error');
            setMessage('Payment was cancelled or failed. Please try again.');
        } else if (sessionId) {
            setStatus('success');
            setMessage('Bank account connected successfully! Your payment is being processed.');
            
            // Redirect back to contracts page after a delay
            setTimeout(() => {
                navigate('/dashboard/contracts');
            }, 3000);
        } else {
            setStatus('error');
            setMessage('Invalid payment return. Please try again.');
        }
    }, [searchParams, navigate]);

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <Card>
                        <CardBody className="text-center">
                            {status === 'loading' && (
                                <>
                                    <h4>Processing...</h4>
                                    <p>Please wait while we process your payment information.</p>
                                </>
                            )}
                            
                            {status === 'success' && (
                                <>
                                    <h4 className="text-success">Payment Initiated!</h4>
                                    <Alert color="success">
                                        {message}
                                    </Alert>
                                    <p>You will be redirected to your contracts page shortly.</p>
                                </>
                            )}
                            
                            {status === 'error' && (
                                <>
                                    <h4 className="text-danger">Payment Error</h4>
                                    <Alert color="danger">
                                        {message}
                                    </Alert>
                                    <Button 
                                        color="primary" 
                                        onClick={() => navigate('/dashboard/contracts')}
                                    >
                                        Return to Contracts
                                    </Button>
                                </>
                            )}
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default PaymentResult;